export default "__VITE_ASSET__CECLfHje__"